import vSpeakText from "./v-speak-text.vue";

export default Vue => {
  Vue.component("v-speak-text", vSpeakText);
};
